export const data = 
    {
      "total": 1,
      "to_be_invoiced": 12,
      "invoiced": 34,
      "in_transit": 50,
      "self_pick": 10,
      "delivered": 23,
      "cancelled": 50,
      "Returned": 50
    };